import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import '../styles/layout.css';

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const glaLogo = "/logo.png";

  return (
    <nav>
      <div className="logo" onClick={() => navigate('/')} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        <img src={glaLogo} alt="GritLab Logo" style={{ height: '40px', width: 'auto', objectFit: 'contain' }} />
        <span style={{ fontWeight: 'bold', fontSize: '1.2rem', color: 'var(--color-text)' }}>Future GRIT Lab Africa</span>
      </div>
      
      <div className="nav-links" id="nav-links">
        {user ? (
          <>
            <button onClick={() => navigate('/dashboard')} className="nav-link" style={{background: 'none', border: 'none', cursor: 'pointer', font: 'inherit'}}>Dashboard</button>
            {user.role !== 'instructor' && user.role !== 'admin' ? (
              <>
                <button onClick={() => navigate('/courses')} className="nav-link" style={{background: 'none', border: 'none', cursor: 'pointer', font: 'inherit'}}>Courses</button>
                <button onClick={() => navigate('/forums')} className="nav-link" style={{background: 'none', border: 'none', cursor: 'pointer', font: 'inherit'}}>Forum</button>
                <button onClick={() => navigate('/attendance')} className="nav-link" style={{background: 'none', border: 'none', cursor: 'pointer', font: 'inherit'}}>Take Attendance</button>
                <button onClick={() => navigate('/certificates')} className="nav-link" style={{background: 'none', border: 'none', cursor: 'pointer', font: 'inherit'}}>Certificates</button>
              </>
            ) : (
              <button onClick={() => navigate('/track-gla')} className="nav-link" style={{ fontWeight: 600, color: '#7A5107', background: 'none', border: 'none', cursor: 'pointer', font: 'inherit' }}>
                <i className="fas fa-chart-line" style={{ marginRight: '0.5rem' }}></i>
                Track GLA
              </button>
            )}
          </>
        ) : null}
        <div className="user-info">
          <div className="user-icon">
            <i className="fas fa-user-circle"></i>
          </div>
          {user && <span id="user-name">{user.name}</span>}
          <button 
            id="auth-btn" 
            onClick={user ? handleLogout : () => navigate('/login')}
            style={{ cursor: 'pointer', background: 'none', border: 'none', font: 'inherit', color: 'inherit' }}
          >
            {user ? 'Logout' : 'Sign In'}
          </button>
        </div>
      </div>

      {/* Mobile Menu Toggle Button */}
      <button id="mobile-menu-btn" className="mobile-menu-btn" onClick={() => {
        const navLinks = document.getElementById('nav-links');
        navLinks.classList.toggle('active');
      }}>
        <i className="fas fa-bars"></i>
      </button>
    </nav>
  );
};

export default Navbar;
